module.exports = __webpack_public_path__ + "static/media/heroBG720.bf01b13e.webp";